<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"
        />

        <div
            class="border bg-white rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 mb-4">* Link Destination Object</p>
            <polymorphic-reference
                :creatable="false"
                :language="form.language"
                v-model="form.document"
                :models="linkableTypes"
                :should-open-new-window=true
                :query="{
                    status_id: 1,
                }"
            />
        </div>

        <input-text
            class="mt-3"
            name="button_text"
            label="* Link Text"
            v-model="form.button_text"
            :error="errors.button_text ? errors.button_text[0] : null"
            :maxlength=255
        />
        <input-checkbox
            name="new_tab"
            label="Opens in new tab?"
            class="mt-3"
            v-model="form.new_tab"
            :error="errors.new_tab ? errors.new_tab[0] : null"
        />

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";
import Reference from "./reference";
import InputCheckbox from "./form/InputCheckbox";
export default {
    name: "InternalLinkForm",
    components: { InputCheckbox, Reference },
    mixins: [crudForm],
    props: {
        linkableTypes: {
            type: Array,
            default: () => [
                "Casino Review",
                "Slot Review",
                "Game Review",
                "Author",
                "Category",
            ],
        },
    },
    data() {
        return {
            form: {
                button_text: this.getFormData("button_text"),
                document_id: this.getFormData("document_id"),
                document: this.getFormData("document"),
                new_tab: this.getFormData("new_tab") ? true : false,
            },
        };
    },
    watch: {
        "form.document": function (newValue) {
            this.form.document_id = newValue?.id || null;
            this.form.document_type = newValue?.model_name || null;
        },
    },
};
</script>
